<template>
    <div>

        <div v-if="visualizar==='consulta'">
            <!-- titulo y boton crear -->
            <v-row class="d-flex flex-row-reverse pt-0">
                <v-col class="pt-0" cols="auto">
                    <v-btn class="btn_block_style2" dark >Historico</v-btn>
                </v-col>

                <v-col class="pt-0" cols="auto">
                    <v-btn class="btn_block_style2" dark  @click="addItem">Evaluación</v-btn>
                </v-col>
            </v-row>




            <!-- consultar -->
            <v-card>
                <v-col class="d-flex justify-space-between pt-0">

                    <v-col class="pt-0" cols="4" sm="4" md="4">
                        <v-select
                        label="Periodo"
                        v-model="periodo"
                        :items="items"
                        item-value="id" item-text="nombre"
                        dense
                        ></v-select>
                    </v-col>


                    <v-col class="pt-0" cols="4">
                        <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line hide-details ></v-text-field>
                    </v-col>
                </v-col>


                <v-data-table :headers="headers" :items="data" :search="search" :sort-by="['id']" :sort-desc="[true]" class="elevation-1" fixed-header>

                    <!-- <template v-slot:item.tipo="{ item }">
                        <v-chip v-if="item.es_sucursal===0" color="#6abf69" pill dark class="font-weight-black">
                            Principal
                        </v-chip>


                        <v-chip v-else color="#0277bd" pill dark class="font-weight-black">
                            Sucursal
                        </v-chip>

                    </template> -->




                    <template v-slot:item.action="{ item }">
                        <v-btn class="mx-2" fab x-small color="#388e3c" dark title="VER" @click="verColegio(item)">
                            <v-icon>fa-eye</v-icon>
                        </v-btn>

                        <v-btn class="mx-2" fab x-small color="#01579b" dark title="COPIAR" @click="verColegio(item)">
                            <v-icon>fa-copy</v-icon>
                        </v-btn>

                        <v-btn class="mx-2" fab x-small color="#ffbc00" dark title="EDITAR" @click="editItem(item)">
                            <v-icon>fa-pencil-alt</v-icon>
                        </v-btn>

                        <v-btn class="mx-2" fab x-small color="#e53935" dark title="ELIMINAR" >
                            <v-icon>fa-trash-alt</v-icon>
                        </v-btn>

                        <v-btn class="mx-2" fab x-small color="#424242" dark title="IMPRIMIR" >
                            <v-icon>fa-print</v-icon>
                        </v-btn>
                    </template>


                </v-data-table>
            </v-card>
            <!--  <pre>{{getConfiguracion}}</pre> -->

        </div>


        <div v-if="visualizar==='wizard'">

            <Wizard></Wizard>
        </div>





    </div>
</template>




<script>
    // import axios from '../../../../helpers/axios'
    import { mapMutations, mapGetters } from 'vuex';
    import Wizard from './wizard.vue'
    export default {
        components:{
            Wizard
        },


        data: () => ({
            search: '',
            dialog: false,
            visualizar: 'consulta',


            headers: [
                { text: 'PERIODO', align: 'left', value: 'periodo', class:'secondary'},
                { text: 'CLASE', value: 'clase' , class:'secondary'},
                { text: 'TIPO EVALUACIÓN', value: 'tipo' , class:'secondary'},
                { text: 'PROGRAMACIÓN DE EVALUACIÓN', value: 'programacion' , class:'secondary'},
                { text: 'CURSO', value: 'curso' , class:'secondary'},
                { text: 'ESTADO', align:'center', value: 'estado', sortable: false , class:'secondary'},
                { text: '', value: 'action', sortable: false , class:'secondary'}
            ],




            data: [
                {
                    periodo: 'Frozen Yogurt',
                    clase: 159,
                    tipo: 6.0,
                    programacion: 24,
                    curso: 4.0,
                    estado: 'LINK',
                },
                {
                    periodo: 'Ice cream sandwich',
                    clase: 237,
                    tipo: 9.0,
                    programacion: 37,
                    curso: 4.3,
                    estado: 'LINK',
                },
                {
                    periodo: 'Eclair',
                    clase: 262,
                    tipo: 16.0,
                    programacion: 23,
                    curso: 6.0,
                    estado: 'LINK',
                },
                {
                    periodo: 'Cupcake',
                    clase: 305,
                    tipo: 3.7,
                    programacion: 67,
                    curso: 4.3,
                    estado: 'LINK',
                },
                {
                    periodo: 'Gingerbread',
                    clase: 356,
                    tipo: 16.0,
                    programacion: 49,
                    curso: 3.9,
                    estado: 'LINK',
                },
                {
                    periodo: 'Jelly bean',
                    clase: 375,
                    tipo: 0.0,
                    programacion: 94,
                    curso: 0.0,
                    estado: 'LINK',
                },
                {
                    periodo: 'Lollipop',
                    clase: 392,
                    tipo: 0.2,
                    programacion: 98,
                    curso: 0,
                    estado: 'LINK',
                },
                {
                    periodo: 'Honeycomb',
                    clase: 408,
                    tipo: 3.2,
                    programacion: 87,
                    curso: 6.5,
                    estado: 'LINK',
                },
                {
                    periodo: 'Donut',
                    clase: 452,
                    tipo: 25.0,
                    programacion: 51,
                    curso: 4.9,
                    estado: 'LINK',
                },
                {
                    periodo: 'KitKat',
                    clase: 518,
                    tipo: 26.0,
                    programacion: 65,
                    curso: 7,
                    estado: 'KINK',
                },
            ],





            //----------periodo--------
            periodo:{nombre:'',id:0},
            items: [
                { nombre: 'Argelia', id: 1 },
                { nombre: 'Alemania', id:  2 },
                { nombre: 'Argentina', id: 3 },
                { nombre: 'Bahamas', id: 4 },
                { nombre: 'Belice', id: 5 },
            ],

        }),



        computed: {
            ...mapGetters('gestEvaluacion', ['getConfiguracion'])

        },


        mounted() {
            this.loadMain()
        },


        created(){
            this. setTituloMenu("GESTIÓN DE EVALUACIÓN")
        },





        methods: {
            ...mapMutations(['setTituloMenu']),
            ...mapMutations('gestEvaluacion', ['setWizard']),


            //-------mostrar registros------------
            loadMain(){
               /*  axios.get("/manager/colegio")
                .then( response =>{
                    this.colegios = response.data;
                    console.log(this.colegios)
                })

                .catch(e => {
                    console.log(e);
                }) */
            },




            //agregar evaluacion
            addItem(){
                this.visualizar = 'wizard'
                let configWizard = {cod_evaluacion:'', wizard_state: 0, wizard_evento: 'agregar'}


                this.setWizard(configWizard)

            },


        },
    }
</script>









<style scoped>


</style>
